(function () {
  document.querySelectorAll('[data-bhcr-language-selector]').forEach(function (selector) {
    var button = selector.querySelector('.disclosure__button');
    var panel = selector.querySelector('.disclosure__list-wrapper');
    if (!button || !panel) return;

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      panel.toggleAttribute('hidden', expanded);
    });

    selector.addEventListener('focusout', function (event) {
      if (selector.contains(event.relatedTarget)) return;
      button.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
    });
  });
})();
